export const getDomain = () => {
  const hostname = window.location.hostname;
  const domainParts = hostname.split(".");
  const domain = domainParts.slice(-2).join("."); // Get the last two parts of the domain
  return domain
}
export const getBrand = () => {
  switch (getDomain()) {
    case "web.com":
      return "webdotcom";
    case "networksolutions.com":
    case "netsol.com":
      return "networksolutions";
    case "bluehost.com":
      return "bluehost";
    case "hostgator.com":
      return "hostgator";
    case "domain.com":
      return "domaincom";
    case "register.com":
      return "registerdotcom";
    default:
      return "domaincom";
  }
}

export const getBrandId = () => {
  switch (getDomain()) {
    case "web.com":
      return 158;
    case "networksolutions.com":
    case "netsol":
      return 157;
    case "bluehost.com":
      return 101;
    case "hostgator.com":
      return 104;
    case "domain.com":
      return 108;
    case "register.com":
      return 159;
    default:
      return 108;
  }
}

export const getRefreshUrl = () => {
  const brand = getBrand();
  switch (brand) {
    case 'webdotcom':
      return 'https://www.web.com/keep-alive.jsp'

    case 'networksolutions':
      return 'https://www.networksolutions.com/keep-alive.jsp'

    case 'registerdotcom':
      return 'https://www.register.com/keep-alive.jsp'

    case 'domaincom':
      return 'https://www.domain.com/keep-alive.jsp'
  }
}